// extracted by mini-css-extract-plugin
module.exports = {"melodyVideo":"qd","landingPageVideo":"rd","play":"sd","iframeVideo":"td","playHidden":"ud","playVisible":"vd","fullwidth":"wd"};